
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[spaceId]",
      function () {
        return require("private-next-pages/[spaceId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[spaceId]"])
      });
    }
  